import React, { useState, useEffect } from 'react';
import {
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import ProviderUrlEditModal from '../../../components/ProviderUrlEditModal';
import { fetchAllProvidersUrlInfo } from '../../../services/api';

function ProviderUrl(props) {
  const {
    classes: { loading },
  } = props;

  const [providers, setProviders] = useState([]);
  const [providerUnderEdit, setProviderUnderEdit] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [openProviderUrlEditModal, setOpenProviderUrlEditModal] = useState(
    false
  );

  const onClose = () => {
    setOpenProviderUrlEditModal(false);
    setProviderUnderEdit({});
  };

  const onEditProviderUrl = provider => {
    setOpenProviderUrlEditModal(true);
    setProviderUnderEdit(provider);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const providersArray = await fetchAllProvidersUrlInfo();
      setProviders(providersArray);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const providers = await fetchAllProvidersUrlInfo();
      setProviders(providers);
    })();
  }, [openProviderUrlEditModal]);

  return isLoading ? (
    <div className={loading}>
      <CircularProgress />
    </div>) : (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Provider Name</TableCell>
              <TableCell>ProfileUrl</TableCell>
              <TableCell>ProviderUrl</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {providers.map(provider => (
              <TableRow key={provider.id}>
                <TableCell>
                  {provider.firstName + ' ' + provider.lastName}
                </TableCell>
                <TableCell>{provider.profileUrl}</TableCell>
                <TableCell>{provider.providerUrl}</TableCell>
                <TableCell>
                  <IconButton onClick={() => onEditProviderUrl(provider)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {openProviderUrlEditModal && (
          <ProviderUrlEditModal
            provider={providerUnderEdit}
            open={openProviderUrlEditModal}
            onClose={onClose}
          />
        )}
      </>
    );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export default withSnackbar(withStyles(styles)(ProviderUrl));
